import React from 'react'

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import Banner2 from "../components/Banner2";
import Projects from "../components/Projects";
import Social from '../components/Social';

const Proyectos = () => {
  return (
    <div>
      <Navbar />
      <Banner2 heading="PROYECTOS" text="Mis trabajos más recientes" />
      <Projects />
      <Social/>
      <Footer />
    </div>
  )
}

export default Proyectos